<template lang="pug">
  div#app( :class="{ 'fixed-height' : isStartQuiz, 'lead-page': isLeadPages }" )
    component( :is="layout" )
      router-view

</template>

<script>
const Chat = require("twilio-chat");
import gql from "graphql-tag";

// import { FRAGMENT_USER_ALL_FIELDS } from "./graphql/gqlFragments";

import { mapGetters } from "vuex";

export default {
  name: "app",
  metaInfo: {
      title: 'AnyCurb: Real Estate, Homes for Sale, Off-Market Data, Agents',
      meta: [
        {
          name: 'description',
          content: 'The consumer-first online real estate marketplace that connects millions of homeowners to quality buyers and helps facilitate the transaction with partner agents.',
          vmid: 'description',
        },
        {
          property: 'og:type',
          content: 'website',
        },
      ]
    },
  data() {
    return {
      isStartQuiz: false,
      getUser: {},
      skipQuery: true,
      currentTwillioUser: null,
      messagesCounter: 0
    };
  },

  // created() {},

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    layout() {
      return this.$route.meta.layout || "default-layout";
    },

    isLeadPages() {
      return (
        this.$route.name == "agent_profile_leads" || this.$route.name == "lead"
      );
    }
  },

  mounted: function() {
    let self = this;
    this.$root.$on("setStartQuiz", function(e) {
      self.isStartQuiz = e;
    });
  },

  watch: {
    currentUser(newValue) {
      if (newValue.id) {
        this.getTwilioToken();
      }
    }
  },

  methods: {
    getTwilioToken() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation chatsToken {
              chatsToken {
                token
              }
            }
          `
        })
        .then(({ data: { chatsToken: { token } } }) => {
          this.initializeChat(token);
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;
          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        });
    },

    initializeChat(token) {
      Chat.Client.create(token).then(client => {
        this.$twilioClient.client = client;

        this.$store.commit("setIsInitTwilio", true);

        this.createMessagesCounter();
      });
    },

    createMessagesCounter() {
      if (this.$twilioClient.client) {
        const twilioUserId = this.$twilioClient.client.user.identity;

        this.$twilioClient.client.on(
          "messageAdded",
          this.updateMessasgesCounter
        );

        this.$twilioClient.client.getUserChannelDescriptors().then(channels => {
          this.channels = channels.state.items;

          if (channels.state.items.length === 0) {
            this.currentTwillioUser = this.$twilioClient.client.user;
            this.$store.commit("setTwilioMessagesCounter", 0);
          }

          channels.state.items.forEach(channelDescriptor => {
            channelDescriptor.getChannel().then(channel => {
              channel.getMembers().then(members => {
                let currentMemeber = members.find(
                  m => m.identity === twilioUserId
                );

                this.currentTwillioUser = currentMemeber;

                if (channel.lastMessage && channel.lastMessage.index) {
                  this.messagesCounter +=
                    channel.lastMessage.index -
                    currentMemeber.attributes.lastMsgIndex;
                }

                // update Store
                this.$store.commit(
                  "setTwilioMessagesCounter",
                  this.messagesCounter
                );
              });
            });
          });
        });
      }
    },

    updateMessasgesCounter(newMessage) {
      if (newMessage.author != this.currentTwillioUser.identity) {
        this.$store.commit(
          "setTwilioMessagesCounter",
          this.$store.state.twilioMessagesCounter + 1
        );
      }
    }
  },

  beforeDestroy() {
    this.$twilioClient.client.removeAllListeners();
  }
};
</script>

<style src="./app.scss" lang="scss"></style>
